import { useRef } from "react";

import { flexRender, Table } from "@tanstack/react-table";

import HdButton from "../hd-button/HdButton";
import HdLoader from "../hd-loader/HdLoader";

interface HdTableProps<T> {
  table: Table<T>;
}

interface FlexColumnMeta {
  flex: number;
}

function HdTable<T>({ table }: HdTableProps<T>) {
  const tableRef = useRef<HTMLTableSectionElement>(null);

  return (
    <div
      className="flex-grow border"
      style={{
        overflow: "auto", //our scrollable table container
        // position: "relative", //needed for sticky header
        // height: "0", //should be a fixed height
      }}
    >
      <table className="w-full text-bodyTextLight " style={{ display: "grid" }}>
        <thead
          style={
            {
              // display: "grid",
              // position: "sticky",
              // top: 0,
              // zIndex: 0, // 1
            }
          }
        >
          {table.getHeaderGroups().map((headerGroup) => (
            <tr
              key={headerGroup.id}
              className="bg-white border-b"
              style={{ display: "flex", width: "100%" }}
            >
              {headerGroup.headers.map((header) => {
                return (
                  <th
                    key={header.id}
                    colSpan={header.colSpan}
                    className="border-r last:border-r-0  p-3 text-sm"
                    style={{
                      display: "flex",
                      width: header.getSize(),
                      flexGrow: (
                        header.column.columnDef.meta as
                          | FlexColumnMeta
                          | undefined
                      )?.flex,
                    }}
                  >
                    {header.isPlaceholder ? null : (
                      <div>
                        {flexRender(
                          header.column.columnDef.header,
                          header.getContext()
                        )}
                      </div>
                    )}
                  </th>
                );
              })}
            </tr>
          ))}
        </thead>
        <tbody ref={tableRef}>
          {table.getRowModel().rows.map((row) => {
            return (
              <tr
                key={row.id}
                style={{ display: "flex", width: "100%" }}
                className="odd:bg-bodyBg even:bg-white border-b last:border-b-0"
              >
                {row.getVisibleCells().map((cell) => {
                  return (
                    <td
                      key={cell.id}
                      className="align-top border-r last:border-r-0 p-3 text-sm"
                      style={{
                        width: cell.column.getSize(),
                        flexGrow: (
                          cell.column.columnDef.meta as
                            | FlexColumnMeta
                            | undefined
                        )?.flex,
                      }}
                    >
                      {flexRender(
                        cell.column.columnDef.cell,
                        cell.getContext()
                      )}
                    </td>
                  );
                })}
              </tr>
            );
          })}
        </tbody>
      </table>
    </div>
  );
}

interface HdTableNextPageLoaderProps<T> extends HdTableProps<T> {
  canLoadMore: boolean;
  isLoadingNextPage: boolean;
  countLabel: string;
  loadMoreText: string;
  onLoadMore: () => void;
}

HdTable.HdTableNextPageLoader = function <T>({
  canLoadMore,
  isLoadingNextPage,
  onLoadMore,
  countLabel,
  loadMoreText,
  table,
}: HdTableNextPageLoaderProps<T>) {
  return (
    <>
      <div className="mt-5" hidden={!isLoadingNextPage}>
        <HdLoader></HdLoader>
      </div>
      <div className="flex items-center justify-center p-3 mt-5">
        <div>
          <div className="text-center mb-2 text-xs">
            <span className="font-bold">{table.getRowModel().rows.length}</span>
            {countLabel}
          </div>
          <div>
            <HdButton
              variant="gray"
              type="button"
              disabled={isLoadingNextPage}
              size="small"
              className={!canLoadMore ? "invisible" : ""}
              onClick={() => onLoadMore()}
            >
              {loadMoreText}
            </HdButton>
          </div>
        </div>
      </div>
    </>
  );
};

export default HdTable;
